// @ts-nocheck
import { ElbowBlock } from "../models/resistances/ElbowBlock";
import { Tee } from "../models/resistances/Tee";
import { Block } from "../models/shapes/Block";
import { Line } from "../models/shapes/Line";
import { Point } from "../models/Point";
import { getDisplayedShapes, getSelectedShapes, a, getStartLastTouchedSegment, getEndLastTouchedSegment } from "../shared/globalState/a";
import { getShapeRouteId } from "../shared/utils/shapeFilters";
import { DrawingModes } from "../shared/enums";
import { Graf } from "../models/nets/GraphExtension";
import { CONSOLE_STYLE_EMPHASIS } from "../shared/logger/logger";
import { isin } from "../shared/common";
import { singleSource } from "graphology-shortest-path";
import { FlowDirection } from "../shared/types";
import { Branch } from "../models/nets/Branch";
import { mergeGraphNodes, mergeGraphEdges, extractNodeIdsWithFittings } from "./network/NetworkHelpers";

export function getNetworkElementsByNodes(nodes: (string | any)[] | undefined): (Line | Block | ElbowBlock | Tee)[] | null {
    if (!nodes) {
        return null;
    }

    var displayedShapes = getDisplayedShapes() || null;

    if (!displayedShapes) {
        return null;
    }

    var routeElements: (Line | Block | ElbowBlock | Tee)[] = [];

    // Find graph that contains these nodes
    const graf = a.graphs.find(g => {
        for (const node of nodes) {
            const nodeId = typeof node === 'string' ? node : node?.id;
            if (nodeId && g.hasNode(nodeId)) {
                return true;
            }
        }
        return false;
    });

    // Extract all IDs (including fitting IDs) using shared helper
    const uniqueIds = extractNodeIdsWithFittings(nodes, graf, a.graphs);


    for (let i = 0; i < displayedShapes.length; i++) {
        const element: (Line | Block | ElbowBlock | Tee) = displayedShapes[i] as any;

        if (typeof (element as any).hasGraphNode !== 'function') {
            continue;
        }


        // Check if element has any of the IDs (including fitting IDs)
        for (const searchId of uniqueIds) {
            if ((element as Line | ElbowBlock | Tee | Block).hasGraphNode(searchId)) {
                routeElements.push(element);
                break;
            }
        }
    }

    return routeElements;
}

export function addNodesToNetwork(currentSegment: Line) {
    var startSeg = getStartLastTouchedSegment();
    var endSeg = getEndLastTouchedSegment();

    var sCur = currentSegment.start;
    var eCur = currentSegment.end;

    if (Array.isArray(startSeg)) {
        /**
         * текущий отрезок начинается на другом, и в начале более одного отрезка (точнее точки)
         */
        let [seg1, seg2, ...restOfSegments] = startSeg;
        let curPoint = currentSegment.start;

        if (seg1.getWhichEnd(curPoint) === 'start' && seg2.getWhichEnd(curPoint) === 'end') {
            let nodeId = seg2.end.id;
            let graf = Graf.findGraph(a.graphs, [nodeId]);

            if (graf) {
                graf.mergeNode(seg2.end);
                graf.addNode(currentSegment.end);
                graf.addEdge(seg2.end, currentSegment.end);


            }
        }
        else if (seg1.getWhichEnd(curPoint) === 'end' && seg2.getWhichEnd(curPoint) === 'start') {
            // Case 2: seg1 end, seg2 start
        }
        else if (seg1.getWhichEnd(curPoint) === 'start' && seg2.getWhichEnd(curPoint) === 'start') {
            // Case 3: seg1 start, seg2 start
        }
        else if (seg1.getWhichEnd(curPoint) === 'end' && seg2.getWhichEnd(curPoint) === 'end') {
            // Case 4: seg1 end, seg2 end
        }
    }
    else if (Array.isArray(endSeg)) {
        /**
         * текущий отрезок заканчивается на другом, и в конце более одного отрезка (точнее точки)
         */
        let [seg1, seg2, ...restOfSegments] = endSeg;
        let curPoint = currentSegment.end;

        if (seg1.getWhichEnd(eCur) === 'start' && seg2.getWhichEnd(eCur) === 'end') {
            let nodeId = seg2.end.id;
            let graf = Graf.findGraph(a.graphs, [nodeId]);
            if (graf) {
                graf.mergeNode(seg2.end);
                graf.addNode(currentSegment.start);
                graf.addEdge(seg2.end, currentSegment.start);


            }
        }
        else if (seg1.getWhichEnd(eCur) === 'end' && seg2.getWhichEnd(eCur) === 'start') {
            // Case 6: seg1 end, seg2 start
        }
        else if (seg1.getWhichEnd(eCur) === 'start' && seg2.getWhichEnd(eCur) === 'start') {
            // Case 7: seg1 start, seg2 start
        }
        else if (seg1.getWhichEnd(eCur) === 'end' && seg2.getWhichEnd(eCur) === 'end') {
            // Case 8: seg1 end, seg2 end
        }
    }
    else {
        if (!startSeg && !endSeg) {
            // если отрезок создаётся на пустом месте
            let graf = new Graf();

            graf.addNode(sCur);
            graf.addNode(eCur);
            graf.addEdge(sCur, eCur);


            a.graphs.push(graf);
        }
        else if (startSeg && !endSeg) {
            // если отрезок начинается на конце другого отрезка
            let graf = Graf.findGraph(a.graphs, [startSeg.start.id, startSeg.end.id]);

            if (graf) {
                if (startSeg.getWhichEnd(sCur) === 'start') {
                    // если отрезок присоединяется к началу другого отрезка
                    graf.mergeNode(startSeg.start);
                    graf.addNode(eCur);
                    graf.addEdge(startSeg.start, eCur);


                }
                else if (startSeg.getWhichEnd(sCur) === 'end') {
                    // если отрезок присоединяется к концу другого отрезка
                    graf.mergeNode(startSeg.end);
                    graf.addNode(eCur);
                    graf.addEdge(startSeg.end, eCur);


                }
            }
        }
        else if (!startSeg && endSeg) {
            // если отрезок заканчивается на конце другого отрезка
            let graf = Graf.findGraph(a.graphs, [endSeg.start.id, endSeg.end.id]);

            if (graf) {
                if (endSeg.getWhichEnd(eCur) === 'start') {
                    // если отрезок присоединяется к началу другого отрезка
                    graf.mergeNode(endSeg.start);
                    graf.addNode(sCur);
                    graf.addEdge(sCur, endSeg.start);


                }
                else if (endSeg.getWhichEnd(eCur) === 'end') {
                    // если отрезок присоединяется к концу другого отрезка
                    graf.mergeNode(endSeg.end);
                    graf.addNode(sCur);
                    graf.addEdge(sCur, endSeg.end);


                }
            }
        }
    }

    a.graph$.next(a.graphs);
}

export function removeNodesFromNetwork(selectedSegments: Line[]) {

    // найти графы, соответствующие выбранным отрезкам
    for (let i = 0; i < selectedSegments.length; i++) {
        let segment: Line = selectedSegments[i];
        let segmentNodes: string[] = [segment.start.id, segment.end.id];
        let graf = Graf.findGraph(a.graphs, segmentNodes);
        if (graf) {
            for (let j = 0; j < segmentNodes.length; j++) {
                let nodeId = segmentNodes[j];
                if (graf.hasNode(nodeId)) {
                    graf.dropNode(nodeId);
                }
            }
        }
    }

    a.graph$.next(a.graphs);
}

export function copyNodesFromNetwork() {
    var selectedSegments = getSelectedShapes().filter(s => s instanceof Line) as Line[];
    var selectedGrafs = selectedSegments.map(s => Graf.findGraph(a.graphs, [s.start.id, s.end.id])).filter(graf => graf !== null);
    selectedGrafs.forEach(graf => {
        a.graphs.push(graf.copy());
    });
    a.graph$.next(a.graphs);
}

export function updateGraphNodesCoordinatesZoom(graph) {
    graph.forEachNode(node => {
        let attr = graph.getNodeAttributes(node);
        let x = attr.x;
        let y = attr.y;
        let pointsOnTheScreen = getDisplayedShapes().filter(s => s instanceof Line).map(s => [(s as Line).start, (s as Line).end]).flat();
        let nodePoint = pointsOnTheScreen.find(p => p.id === node);
        if (nodePoint) {
            x = nodePoint.x;
            y = nodePoint.y;
            graph.setNodeAttribute(node, 'x', x);
            graph.setNodeAttribute(node, 'y', -y);
        }
    });

    return graph;
}

export function updateGraphNodesCoordinatesPan() {
    a.graphs.forEach(graph => [
        graph.forEachNode(node => {
        })
    ]);
}

/**
 * Adds block connection points as nodes to the graph network
 * @param block - The block whose connection points should be added to the graph
 * @param targetGraph - Optional target graph to add nodes to (if not provided, will search for appropriate graph)
 */
export function addBlockNodesToNetwork(block: Block, targetGraph?: Graf | null) {
    const cpoints = block.getCpoints();
    const cp1 = cpoints.cp1;
    const cp2 = cpoints.cp2;

    if (!cp1) return; // No connection points to add

    // Use the provided target graph if available
    let graf = targetGraph || null;

    // Try to find an existing graph that contains connected segments
    const connectedSegments = block.getConnectedSegments();

    if (!graf && connectedSegments.length > 0) {
        // Collect all graphs from connected segments
        const connectedGraphs = new Set<Graf>();

        connectedSegments.forEach(segment => {
            if (segment && segment.start && segment.end) {
                const segmentGraph = Graf.findGraph(a.graphs, [segment.start.id, segment.end.id]);
                if (segmentGraph) {
                    connectedGraphs.add(segmentGraph);
                }
            }
        });

        // If we found graphs, use the first one and merge others if needed
        if (connectedGraphs.size > 0) {
            const graphsArray = Array.from(connectedGraphs);
            graf = graphsArray[0];

            // If block connects segments from different graphs, merge them
            for (let i = 1; i < graphsArray.length; i++) {
                mergeGraphsAndRemoveRedundant(graf, graphsArray[i]);
            }
        }
    }

    if (!graf) {
        // Create a new graph only if none exists and no target provided
        graf = new Graf();
        a.graphs.push(graf);
    }

    // Add connection point nodes to the graph
    if (cp1 && !graf.hasNode(cp1.id)) {
        graf.addNode(cp1);
    }
    if (cp2 && !graf.hasNode(cp2.id)) {
        graf.addNode(cp2);
    }

    // Add edges between connection points if both exist
    if (cp1 && cp2 && !graf.hasEdge(cp1.id, cp2.id)) {
        graf.addEdge(cp1, cp2);
    }

    // Connect block connection points to their connected segments
    connectedSegments.forEach((segment: Line) => {
        if (isin(segment.start, cp1) || isin(segment.end, cp1)) {
            if (isin(segment.start, cp1)) {
                graf.mergeNode(segment.start);
                if (!graf.hasEdge(segment.start.id, cp1.id)) {
                    graf.addEdge(segment.start, cp1);
                }
            } else if (isin(segment.end, cp1)) {
                graf.mergeNode(segment.end);
                if (!graf.hasEdge(segment.end.id, cp1.id)) {
                    graf.addEdge(segment.end, cp1);
                }
            }
        }

        if (cp2 && (isin(segment.start, cp2) || isin(segment.end, cp2))) {
            if (isin(segment.start, cp2)) {
                graf.mergeNode(segment.start);
                if (!graf.hasEdge(segment.start.id, cp2.id)) {
                    graf.addEdge(segment.start, cp2);
                }
            } else if (isin(segment.end, cp2)) {
                graf.mergeNode(segment.end);
                if (!graf.hasEdge(segment.end.id, cp2.id)) {
                    graf.addEdge(segment.end, cp2);
                }
            }
        }
    });

    // Update the graph observable
    a.graph$.next(a.graphs);
}

export function printGraphs() {
    a.graphs.forEach(graph => {
        // Graph nodes and edges logging removed
    });
}

/**
 * Merges two graphs into one and removes the redundant graph from the global graphs array
 * @param targetGraph - The graph to merge into (this one will be kept)
 * @param sourceGraph - The graph to merge from (this one will be removed)
 */
export function mergeGraphsAndRemoveRedundant(targetGraph: Graf | undefined | null, sourceGraph: Graf | undefined | null) {
    if (!targetGraph || !sourceGraph) {
        return;
    }

    // If they're the same graph, nothing to do
    if (targetGraph === sourceGraph) {
        return;
    }

    try {
        // Merge nodes and edges using shared helpers
        mergeGraphNodes(targetGraph, sourceGraph);
        mergeGraphEdges(targetGraph, sourceGraph);

        // Remove the source graph from the global graphs array
        const sourceGraphIndex = a.graphs.indexOf(sourceGraph);
        if (sourceGraphIndex !== -1) {
            a.graphs.splice(sourceGraphIndex, 1);
        }

        // Clean up graphs that have no elements on the drawing
        cleanupEmptyGraphs();

        // Update the graph observable
        a.graph$.next(a.graphs);
    } catch (error) {
        // Error merging graphs, ignore
    }
}

/**
 * Removes graphs that have no nodes or no associated elements on the drawing
 */
function cleanupEmptyGraphs() {

    const displayedShapes = getDisplayedShapes();
    if (!displayedShapes) {
        return;
    }

    // Filter shapes that can have graph nodes
    const shapesWithNodes = displayedShapes.filter(shape =>
        typeof (shape as any).hasGraphNode === 'function'
    ) as (Line | Block | ElbowBlock | Tee)[];

    // Track graphs to remove
    const graphsToRemove: Graf[] = [];

    a.graphs.forEach((graph, index) => {
        // Check if graph has any nodes
        const nodeIds = Array.from(graph.nodes());

        if (nodeIds.length === 0) {
            graphsToRemove.push(graph);
            return;
        }

        // Check if any displayed shape has any of this graph's nodes
        const hasAssociatedShapes = shapesWithNodes.some(shape => {
            return nodeIds.some(nodeId => {
                if (typeof nodeId === 'string') {
                    return shape.hasGraphNode(nodeId);
                }
                return false;
            });
        });

        if (!hasAssociatedShapes) {
            graphsToRemove.push(graph);
        }
    });

    // Remove marked graphs
    graphsToRemove.forEach(graph => {
        const index = a.graphs.indexOf(graph);
        if (index !== -1) {
            a.graphs.splice(index, 1);
        }
    });

}

export function mergeSegmentGraphWidthTeeGraph(segmentGraph: Graf | undefined, teeGraph: Graf | undefined) {
    // Validate input parameters
    if (!segmentGraph || !teeGraph) {
        return;
    }

    // Validate that both graphs have the required methods
    if (typeof segmentGraph.nodes !== 'function' || typeof teeGraph.nodes !== 'function') {
        return;
    }

    try {
        // Use shared merge functions
        mergeGraphNodes(segmentGraph, teeGraph);
        mergeGraphEdges(segmentGraph, teeGraph);

        a.graph$.next(a.graphs);
    } catch (error) {
        // Error merging graphs, ignore
    }
}

/**
 * Adds fitting nodes (ElbowBlock or Tee) to the graph network using metadata approach
 * Instead of creating separate nodes for fitting points, this function adds fitting metadata
 * to existing segment endpoint nodes, creating a merged node representation.
 * 
 * @param fitting - The fitting whose connection points should be added to the graph
 * @param targetGraph - Optional target graph to add nodes to (if not provided, will search for appropriate graph)
 */
export function addFittingNodesToGraphForFitting(fitting: ElbowBlock | Tee, targetGraph?: Graf | null) {

    // Find the graph that contains the segments this fitting connects to
    const crucialPoints = fitting.getCrucialPoints();
    const start = crucialPoints.start;
    const end = crucialPoints.end;
    const mid = crucialPoints.mid || null;

    // Find segments that this fitting connects to by checking their connection points
    const connectedSegments = getDisplayedShapes()
        .filter(s => s instanceof Line)
        .filter((line: Line) => {
            return (start && (line.start.equals(start) || line.end.equals(start))) ||
                (end && (line.start.equals(end) || line.end.equals(end))) ||
                (mid && (line.start.equals(mid) || line.end.equals(mid)));
        }) as Line[];


    // For tees, we may not have connected segments initially, but we still need to process them
    if (connectedSegments.length === 0 && !(fitting instanceof Tee)) return;

    // Use the provided target graph if available
    let graf = targetGraph || null;

    // If no target graph provided, find the graph from connected segments
    if (!graf && connectedSegments.length > 0) {
        const firstSegment = connectedSegments[0];
        graf = Graf.findGraph(a.graphs, [firstSegment.start.id, firstSegment.end.id, firstSegment.mid.id]);
    }

    if (!graf) {
        // Create new graph if none found
        graf = new Graf();
        a.graphs.push(graf);
    }

    /**
     * Processes a fitting point and adds metadata to the corresponding segment endpoint node
     * @param fittingPoint - The fitting's crucial point (start, end, or mid)
     */
    const addFittingMetadataToSegmentNode = (fittingPoint: Point | undefined | null) => {
        if (!fittingPoint) return;

        // Find all segment endpoints that coincide with this fitting point
        const segmentEndpoints: Point[] = connectedSegments
            .map(seg => [seg.start, seg.end])
            .flat()
            .filter(sp => sp && sp.equals(fittingPoint));

        if (segmentEndpoints.length === 0) {
            // No segment endpoint at this location - just add the fitting point as a regular node
            if (!graf.hasNode(fittingPoint.id)) {
                graf.addNode(fittingPoint);
            }
            return;
        }

        // Use the first segment endpoint as the primary node
        const primarySegmentEndpoint = segmentEndpoints[0];
        const primaryNodeId = primarySegmentEndpoint.id;

        // Ensure the segment endpoint node exists in the graph
        if (!graf.hasNode(primaryNodeId)) {
            graf.addNode(primarySegmentEndpoint);
        } else {
            (graf as any).mergeNode(primarySegmentEndpoint);
        }

        // Collect all segment endpoint IDs at this location
        const segmentEndpointIds = segmentEndpoints.map(ep => ep.id);

        // Add fitting metadata to the primary node
        (graf as any).addFittingMetadata(primaryNodeId, {
            fittingId: fittingPoint.id,
            fittingType: (fitting as any).constructor.name,
            segmentEndpointIds: segmentEndpointIds
        });

    };

    // Process all crucial points of the fitting
    addFittingMetadataToSegmentNode(crucialPoints.start);
    addFittingMetadataToSegmentNode(crucialPoints.end);
    addFittingMetadataToSegmentNode(crucialPoints.mid);

    // For tees, ensure all connection points are connected to each other
    // We need to connect the Tee to the mid points of connected line segments
    if (fitting instanceof Tee && crucialPoints.start && crucialPoints.end && crucialPoints.mid) {
        // Find the actual node IDs (might be segment endpoint IDs with metadata)
        const startNodeId = (graf as any).findNodeByAnyId ? (graf as any).findNodeByAnyId(crucialPoints.start.id) : crucialPoints.start.id;
        const endNodeId = (graf as any).findNodeByAnyId ? (graf as any).findNodeByAnyId(crucialPoints.end.id) : crucialPoints.end.id;
        const midNodeId = (graf as any).findNodeByAnyId ? (graf as any).findNodeByAnyId(crucialPoints.mid.id) : crucialPoints.mid.id;

        // Find the mid points of line segments that connect to this Tee
        const connectedLineMidPoints: Point[] = [];
        connectedSegments.forEach(seg => {
            // Check if this segment's start or end connects to the Tee
            if (seg.start.id === startNodeId || seg.start.id === endNodeId || seg.start.id === midNodeId ||
                seg.end.id === startNodeId || seg.end.id === endNodeId || seg.end.id === midNodeId) {
                // Add the segment's mid point
                connectedLineMidPoints.push(seg.mid);
            }
        });


        // Connect each line mid point to the corresponding Tee point
        connectedSegments.forEach(seg => {
            // If segment end is tee.start (base1), connect line.mid to tee.start
            if (seg.end.id === startNodeId && seg.mid) {
                if (!graf.hasEdge(seg.mid.id, startNodeId)) {
                    try {
                        graf.addEdge(seg.mid, crucialPoints.start);
                    } catch (_) { }
                }
            }
            // If segment start is tee.start (base1), connect tee.start to line.mid
            if (seg.start.id === startNodeId && seg.mid) {
                if (!graf.hasEdge(startNodeId, seg.mid.id)) {
                    try {
                        graf.addEdge(crucialPoints.start, seg.mid);
                    } catch (_) { }
                }
            }

            // If segment end is tee.end (base2), connect line.mid to tee.end
            if (seg.end.id === endNodeId && seg.mid) {
                if (!graf.hasEdge(seg.mid.id, endNodeId)) {
                    try {
                        graf.addEdge(seg.mid, crucialPoints.end);
                    } catch (_) { }
                }
            }
            // If segment start is tee.end (base2), connect tee.end to line.mid
            if (seg.start.id === endNodeId && seg.mid) {
                if (!graf.hasEdge(endNodeId, seg.mid.id)) {
                    try {
                        graf.addEdge(crucialPoints.end, seg.mid);
                    } catch (_) { }
                }
            }

            // If segment end is tee.mid (side), connect line.mid to tee.mid
            if (seg.end.id === midNodeId && seg.mid) {
                if (!graf.hasEdge(seg.mid.id, midNodeId)) {
                    try {
                        graf.addEdge(seg.mid, crucialPoints.mid);
                    } catch (_) { }
                }
            }
            // If segment start is tee.mid (side), connect tee.mid to line.mid
            if (seg.start.id === midNodeId && seg.mid) {
                if (!graf.hasEdge(midNodeId, seg.mid.id)) {
                    try {
                        graf.addEdge(crucialPoints.mid, seg.mid);
                    } catch (_) { }
                }
            }
        });
    }

    // Update the graph
    a.graph$.next(a.graphs);
}

export function findElementByNodeId(nodeId: string) {
    let elements = getDisplayedShapes() || [];
    for (const element of elements) {
        if (element.hasGraphNode(nodeId)) {
            return element as Line | Block | ElbowBlock | Tee;
        }
    }
    return undefined;
}

// ==================== GRAPH ANALYSIS FUNCTIONS ====================

/**
 * Gets the degree distribution of nodes in a graph
 * @param graph - The graph to analyze
 * @returns Array of node degrees
 */
function getDegree(graph: any) {
    return Array.from(graph._nodes).map((node: any) => graph.degree(node[0]));
}

/**
 * Detects the source node in a graph based on degree analysis and fitting metadata
 * @param graph - The graph to analyze
 * @param sourceIndixes - Array of node indices with degree 1
 * @returns The ID of the detected source node
 */
function detectSource(graph: Graf, sourceIndixes: number[]): string {

    let possibleSourceNodes: string[] = [];

    for (const index of sourceIndixes) {
        const nodeId = graph.nodes()[index];
        const nodeAttrs = graph.getNodeAttributes(nodeId);

        // Check if this node has fitting metadata (connected to block/elbow/tee)
        const hasFittingMetadata = nodeAttrs && (
            nodeAttrs.fittingMetadata ||
            nodeAttrs.fittingType ||
            nodeAttrs.fittingId ||
            (nodeAttrs.fittings && nodeAttrs.fittings.length > 0)
        );

        // Only consider nodes that are NOT connected to fittings as potential sources
        if (!hasFittingMetadata) {
            possibleSourceNodes.push(nodeId);
        }
    }

    let result;

    if (possibleSourceNodes.length === 1) {
        // Only one clean Line node - use it as source
        result = possibleSourceNodes[0];
    } else if (possibleSourceNodes.length > 1) {
        // Multiple clean Line nodes - use the first one
        result = possibleSourceNodes[0];
    } else {
        // No clean Line nodes found - all nodes are connected to fittings
        result = null;
    }
    return result;
}

/**
 * Processes a single graph item for network analysis
 * @param item - The graph to process
 * @param sigmaInstance - Sigma.js instance for visualization (optional)
 * @returns Object containing processed graph and terminal paths
 */
function processGraphItem(item: Graf, sigmaInstance?: any) {
    // Update nodes coordinates zoom
    let graph = item;

    // Set updated graph instance (only if sigmaInstance is provided)
    if (sigmaInstance) {
        sigmaInstance.setGraph(graph);
    }

    // Get degree distribution of nodes
    let degrees = getDegree(graph);

    // Take first node (source)
    let sourceIndixes = degrees.map((degree, index) => degree === 1 ? index : null).filter(index => index !== null);

    let sourceId = detectSource(graph, sourceIndixes);
    
    
    // Early return if no valid source found
    if (!sourceId) {
        return { graph, terminalPaths: [] };
    }
    
    // Find all paths starting from source
    let paths = singleSource(graph, sourceId);
    

    // Collect all valid terminal paths
    let terminalPaths: any[] = [];

    // Iterate over found paths
    Object.keys(paths).forEach(key => {
        const path = paths[key];
        
        // Skip invalid paths
        if (!path || !Array.isArray(path) || path.length === 0) {
            return;
        }

        let lastNode = path[path.length - 1]; // Last node in the path
        
        // Skip if last node is not a valid node ID
        if (!lastNode || typeof lastNode !== 'string') {
            return;
        }
        
        // Skip if path contains the source node more than once (shouldn't happen in trees, but safety check)
        const sourceOccurrences = path.filter(node => node === sourceId).length;
        if (sourceOccurrences > 1) {
            return;
        }
        
        // Skip if path contains duplicate nodes (except source at start)
        const uniqueNodes = new Set(path);
        if (uniqueNodes.size !== path.length) {
            return;
        }
        
        let lastNodeDegree = graph.degree(lastNode); // Degree of last node

        // Check conditions: last node must be terminal (degree 1) and path must have more than source node
        if (lastNodeDegree === 1 && path.length > 1 && lastNode !== sourceId) {
            // Remove any duplicate nodes from path (keep first occurrence, maintain order)
            const seen = new Set<string>();
            const deduplicatedPath: string[] = [];
            for (const nodeId of path) {
                if (!seen.has(nodeId)) {
                    seen.add(nodeId);
                    deduplicatedPath.push(nodeId);
                }
            }
            
            // Only add path if deduplication didn't remove nodes (paths shouldn't have duplicates)
            // If it did, log a warning as this indicates a potential issue with singleSource or graph structure
            if (deduplicatedPath.length !== path.length) {
                console.warn(`[processGraphItem] Path contained duplicate nodes. Original length: ${path.length}, Deduplicated: ${deduplicatedPath.length}. Path:`, path);
                // Use deduplicated path to prevent issues downstream
                terminalPaths.push(deduplicatedPath);
            } else {
                terminalPaths.push(path); // Collect path if condition is met
            }
        }
    });

    return { graph, terminalPaths }; // Return both processed graph & filtered paths
}

/**
 * Main function for creating and processing node graphs for network analysis
 * @param graphs - Array of graphs to process
 * @param sigmaInstance - Sigma.js instance for visualization (optional)
 * @returns Array of processed graph results with terminal paths
 */
export function createNodeGraph(graphs: Graf[], sigmaInstance?: any) {
    // Use .map() to transform each item while collecting results
    return graphs.map(item => processGraphItem(item, sigmaInstance));
}

export function createNodeGraphSingle(graf: Graf) {
    return processGraphItem(graf);
}

/**
 * Returns an array of terminal paths representing network loops
 * This function finds the graph containing the selected segments and returns terminal paths
 * @param selectedSegments - Array of selected line segments
 * @param graphs - Array of graphs to search in
 * @param sigmaInstance - Sigma.js instance for visualization
 * @returns Array of terminal paths or null if no graph found
 */
export function getNetworkLoops(
    selectedSegments: Line[],
    graphs: any[],
    sigmaInstance: any
): any[] | null {
    if (selectedSegments.length) {
        let arbitraryPointOfSelectedSegments = selectedSegments[0].start;
        let id = [arbitraryPointOfSelectedSegments.id];

        let graph = Graf.findGraph(graphs, id);
        
        if (graph) {
            let graphResult = createNodeGraph([graph], sigmaInstance)[0];
            return graphResult.terminalPaths;
        }
    }
    return null;
}

export function getNetworkLoopsInGraf(graf: Graf): string[][]{
    if (!graf) {
        console.error(`!! No graf. Return`);
        return;
    }

    let graphResult = createNodeGraph([graf])[0];
    return graphResult.terminalPaths;    
}

export function getBranchByNodeId(nodeId: string) {
    let branches = a.branches;
    if (!branches.length) {
        return null;
    }
    let branch = branches.find(b => b.elements.some(e => e.hasGraphNode(nodeId)));
    return branch;
}

export function getBranchPathByNodeId(nodeId: string): string[] {
    let branch = getBranchByNodeId(nodeId);
    if (!branch) {
        return [];
    }
    let path = branch.path;
    return path;
}

export function getBranchByElement(element: Line | Block | ElbowBlock | Tee) {
    let branches = a.branches;
    if (!branches.length) {
        return null;
    }
    
    // Find all branches that contain this element
    const candidateBranches = branches.filter(b => b.elements.some(e => e.id === element.id));
    
    if (candidateBranches.length === 0) {
        return null;
    }
    
    // If only one branch contains the element, return it
    if (candidateBranches.length === 1) {
        return candidateBranches[0];
    }
    
    // Multiple branches contain the element (shared segment scenario)
    // Prefer the branch that also contains the element's connected neighbors
    let connectedSegments: Line[] = [];
    
    if (element instanceof Line) {
        const segments = element.getConnectedSegments();
        connectedSegments = segments.filter(seg => seg instanceof Line) as Line[];
    } else if ((element as any) instanceof Block || (element as any) instanceof ElbowBlock || (element as any) instanceof Tee) {
        const segments = (element as Block | ElbowBlock | Tee).getConnectedSegments();
        connectedSegments = segments.filter(seg => seg instanceof Line) as Line[];
    }
    
    // Score each branch based on how many connected neighbors it contains
    const branchScores = candidateBranches.map(branch => {
        const neighborCount = connectedSegments.filter(seg => 
            branch.elements.some(e => e.id === seg.id)
        ).length;
        
        return {
            branch,
            neighborCount,
            elementCount: branch.elements.length
        };
    });
    
    // Prefer branch with most connected neighbors
    branchScores.sort((a, b) => {
        // First sort by neighbor count (descending)
        if (b.neighborCount !== a.neighborCount) {
            return b.neighborCount - a.neighborCount;
        }
        // If tie, prefer smaller branch (more specific)
        return a.elementCount - b.elementCount;
    });
    
    // Return the branch with highest score
    return branchScores[0].branch;
}

export function assignTeeFlowDirections(networkElements: (Line | ElbowBlock | Tee | Block)[]): void {

    let teesElements = networkElements.filter(e => e instanceof Tee) as Tee[];
    if (teesElements.length === 0) {
        return;
    }

    let arbitrarySegmentForGraphTaking = teesElements[0].getConnectedSegments()[0];
    if (!arbitrarySegmentForGraphTaking) {
        return;
    }
    let graf = arbitrarySegmentForGraphTaking.getGraph();
    if (!graf) {
        return;
    }

    teesElements.forEach((tee: Tee) => {
        let crucialPoints = tee.getCrucialPoints();
        let teeNodes = [
            {nodeId: getRelatedNodeFromFittingNode(crucialPoints.start.id, graf), pointKey: 'start'},
            {nodeId: getRelatedNodeFromFittingNode(crucialPoints.end.id, graf), pointKey: 'end'},
            {nodeId: getRelatedNodeFromFittingNode(crucialPoints.mid.id, graf), pointKey: 'mid'},
        ];
        /**
         * Tees' and Elbows' CrusialPoints does not exist in the graphs directly - they
         * exists as Lines' nodes attributes. So it is necessary to find related line's node and operate 
         * with it further instead of using tee's crusualPoints directly to find a graph
         */

        // For each connection point (start, end, mid), find the terminal or open end
        // by following the path away from the tee
        teeNodes.forEach((teeNode: {nodeId: string, pointKey: string}) => {
            // Skip if nodeId is null or undefined
            if (!teeNode.nodeId) {
                console.log(`Could not find Line node ID for fitting node`);
                return;
            }

            // Find terminal or open end in the direction away from the tee
            // Use the Line's node ID instead of the fitting point
            const terminalOrOpenEndNodeId = findTerminalOrOpenEnd(teeNode.nodeId, graf, teeNodes.map(node => node.nodeId));


            if (terminalOrOpenEndNodeId) {
                const isTerminal = graf.getNodeAttributes(terminalOrOpenEndNodeId)?.isTerminal;
                const isOpenEnd = graf.getNodeAttributes(terminalOrOpenEndNodeId)?.isOpenEnd;
                // Set flow direction based on whether it's a terminal or open end
                // Use information from graph node attributes
                const terminalFlowDirection = getFlowDirectionForTerminalOrOpenEnd(terminalOrOpenEndNodeId, graf);

                // Invert the flow direction: if terminal has IN, tee connection has OUT and vice versa
                let teeFlowDirection;
                if (isTerminal) {
                    teeFlowDirection = terminalFlowDirection === FlowDirection.IN ? FlowDirection.OUT : FlowDirection.IN;
                }
                else {
                    teeFlowDirection = terminalFlowDirection;
                }

                // Update the tee's flow direction at this point
                const currentFlowDirections = crucialPoints.flowDirections || {};
                currentFlowDirections[teeNode.pointKey] = teeFlowDirection;

                // Update the tee element
                tee.updateFlowProperties({
                    [teeNode.pointKey]: teeFlowDirection
                });
            }
        });
    });
}

export function getRelatedNodeFromFittingNode(fittingNodeId: string, graf: Graf | null | undefined): string | null {
    if (!graf || !fittingNodeId) {
        return null;
    }
    // Use the new method to find the Line's node ID from the fitting node ID
    return graf.getLineNodeIdByFittingNodeId(fittingNodeId);
}

/**
 * Find terminal or open end by following the path from a given point
 * 
 * This function uses graphology's shortest path algorithms to find paths to terminal nodes.
 * For each neighbor of the start node, it finds the shortest path to any terminal node.
 * 
 * @param lineNodeFromTeeCrusialPointId - Какая-то точка тройника
 * @param graph - The graph to search in
 * @returns The terminal or open end node ID, or null if not found
 */
function findTerminalOrOpenEnd(lineNodeFromTeeCrusialPointId: string, graph: Graf, teeNodes: string[]): string | null {
    if (!graph || !graph.hasNode(lineNodeFromTeeCrusialPointId)) {
        return null;
    }

    let branchPath = getBranchPathByNodeId(lineNodeFromTeeCrusialPointId);
    if (!branchPath.length) {
        return null;
    }

    for (let i = 0; i < branchPath.length; i++) {
        const nodeId = branchPath[i];
        if (nodeId === lineNodeFromTeeCrusialPointId) {
            if (i !== 0) {
                let previousNodeId = branchPath[i-1];
                if(teeNodes.includes(previousNodeId)){
                    break;
                }
                else {
                    return branchPath[0];
                }
            } else {
                // At start of path, check if next node is a tee node
                if (i + 1 < branchPath.length) {
                    let nextNodeId = branchPath[i + 1];
                    if (teeNodes.includes(nextNodeId)) {
                        break;
                    } else {
                        return branchPath[branchPath.length - 1];
                    }
                } else {
                    // Only one node in path
                    return branchPath[0];
                }
            }
        }
    }

    for(let i = branchPath.length - 1; i >= 0; i--) {
        const nodeId = branchPath[i];
        if (nodeId === lineNodeFromTeeCrusialPointId) {
            if (i !== branchPath.length - 1) {
                let nextNodeId = branchPath[i+1];
                if(teeNodes.includes(nextNodeId)){
                    break;
                }
                else {
                    return branchPath[branchPath.length - 1];
                }
            } else {
                // At end of path, check if previous node is a tee node
                if (i - 1 >= 0) {
                    let previousNodeId = branchPath[i - 1];
                    if (teeNodes.includes(previousNodeId)) {
                        break;
                    } else {
                        return branchPath[0];
                    }
                } else {
                    // Only one node in path
                    return branchPath[branchPath.length - 1];
                }
            }
        }
    }
    return null;
}

/**
 * Determine flow direction for a tee connection based on terminal/open end type
 * Uses information from graph node attributes, not from element classes
 */
function getFlowDirectionForTerminalOrOpenEnd(terminalNodeId: string | null, graph: Graf): FlowDirection {
    if (!terminalNodeId || !graph) {
        return FlowDirection.UNKNOWN;
    }

    // Get the node's attributes from the graph
    const nodeAttrs = graph.getNodeAttributes(terminalNodeId);

    if (!nodeAttrs) {
        return FlowDirection.UNKNOWN;
    }

    // If flow direction is set on the node, use it (most reliable source)
    // This works for both terminal nodes and open ends
    if (nodeAttrs.flowDirection) {
        return nodeAttrs.flowDirection as FlowDirection;
    }

    // If no flow direction is set, we can't determine it
    // Flow direction should be set during graph building or flow propagation
    return FlowDirection.UNKNOWN;
}
